import { Injectable } from '@angular/core';

@Injectable()
export class LogService {
  log(file: string, label: string, toLog: any) {
    // console.log(file, label, toLog);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/logging.service.ts